// extracted by mini-css-extract-plugin
export var dropdownButton = "_3b-0";
export var fullWidthDropdownButton = "_3b-1";
export var icon = "_3b-3";
export var iconPlaceholder = "_3b-2";
export var menuItemRow = "_3b-5";
export var shortcutContainer = "_3b-4";